<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Merchantrade Money OTP</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card text-center">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="rate-box otp-box otp" v-if="authMode === 'OTP'">
						<div class="form-card-forms">
							<h4 class="header">Verification</h4>
							<h4 class="detail">To proceed, please enter your OTP number</h4>
							<div class="otp-form">
								<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
									<div class="form-group">
										<input type="num" class="form-control otp" id="otp" name="OTP" style="height:75px"
											   v-only-numeric="" autocomplete="off" v-model="vModel.OTP"
											   v-validate="'required|min:6|max:6'" :class="{'input': true, 'is-danger': errors.has('OTP') }" />
										<div v-show="errors.has('OTP')" class="help is-danger">
											{{ errors.first('OTP') }}
										</div>
									</div>
									<button class="btn main-btn">Verify</button>
								</form>
							</div>
						</div>
					</div>
					<div class="rate-box otp-box otp" v-if="authMode === 'PassCode'">
						<div class="form-card-forms">
							<h4 class="header">Verification</h4>
							<h4 class="detail">To proceed, please enter your Pass Code number</h4>
							<div class="otp-form">
								<form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
									<div class="form-group">
										<input type="num" class="form-control otp" id="passcode" name="PASSCODE" style="height:75px"
											   v-only-numeric="" autocomplete="off" v-model="vModel.PASSCODE"
											   v-validate="'required|min:6|max:6'" :class="{'input': true, 'is-danger': errors.has('PASSCODE') }" />
										<div v-show="errors.has('PASSCODE')" class="help is-danger">
											{{ errors.first('PASSCODE') }}
										</div>
									</div>
									<button class="btn main-btn">Verify</button>
								</form>
							</div>
						</div>
					</div>
					<div class="rate-option-btn">
						<div class="submit-option maxw-700">
							<div class="left-option">
								<button type="button" class="btn submit-lefticon-btn" @click="onCancel">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</button>
							</div>
							<div class="right-option" v-if="authMode === 'OTP'">
								<p>
									Didn't get the code? <a href="javascript:void(0)" class="resend" @click="onResendOtp">Resend OTP?</a>
								</p>
							</div>
						</div>
					</div>
					<!-- eo main card -->
				</div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import commonService from "../../services/common";

	export default {
		name: "transactionotp",
		extends: Base,
		components: {
			Action,
			Mode
		},
		created() {
			this.url.update = "payment/mmoney/submittransaction";
			this.url.otpResend = "payment/mmoney/regenerateMMPayOtp";
			this.url.cancel = "payment/mmoney/cancel";
			const authMode = commonService.getStorage("AuthMode");

			if (authMode === "NoAuth") {
				this.submitWithoutOtp();
			}
		},
		beforeRouteEnter(to, from, next) {
			if (commonService.getStorage("transactionRefNo") != null) {
				next();
			} else {
				next({ path: "/dashboard" });
			}
		},
		data() {
			return {
				authMode: commonService.getStorage("AuthMode"), // OTP | PASSCODE | NoAuth
				isProcessing: false,
				vModel: {
					TransactionRefNumber: "",
					OTP: "",
					PASSCODE: ""
				}
			};
		},
		methods: {
			onSubmit: function () {
				var self = this;
				var txnRefNumber = commonService.getStorage("transactionRefNo");
				const authMode = commonService.getStorage("AuthMode")
				if (authMode === "PassCode") {
					self.vModel.OTP = self.vModel.PASSCODE;
				}
				if (self.isProcessing) return false;
				self.$validator.validateAll().then(result => {
					if (result && self.beforeSave()) {
						self.isProcessing = true;
						self.vModel.TransactionRefNumber = txnRefNumber;
						self.$http.post(self.url.update, self.vModel).then(
							response => {
								if (response.body.Status == "OTP_ERROR") {
									self.$toastr("error", response.body.Description);
									self.isProcessing = false;
								} else {
									commonService.setStorage("transactionRefNo", "");
									self.isProcessing = false;
									this.$router.push("/transaction/confirmation/" + txnRefNumber);
								}
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onResendOtp: function () {
				var self = this;
				self.isProcessing = true;
				self.vModel.TransactionRefNumber = commonService.getStorage(
					"transactionRefNo"
				);
				self.$http.post(self.url.otpResend, self.vModel).then(
					response => {
						self.$toastr("success", "OTP Resend Successfully");
						self.isProcessing = false;
					},
					error => {
						self.isProcessing = false;
					}
				);
			},
			onCancel: function () {
				var self = this;
				var txnRefNumber = commonService.getStorage("transactionRefNo");
				self.isProcessing = true;
				self.vModel.TransactionRefNumber = commonService.getStorage(
					"transactionRefNo"
				);
				self.$http.post(self.url.cancel, self.vModel).then(
					response => {
						commonService.setStorage("transactionRefNo", "");
						self.isProcessing = false;
						this.$router.push("/transaction/confirmation/" + txnRefNumber);
					},
					error => {
						self.isProcessing = false;
					}
				);
			},
			onClearForm: function () {
				this.vModel = getDefaultData();
				this.errors.clear();
			},
			submitWithoutOtp() {
				const txnRefNumber = commonService.getStorage("transactionRefNo");
				if (!txnRefNumber || this.isProcessing) return;

				this.isProcessing = true;

				this.vModel = {
					TransactionRefNumber: txnRefNumber,
					OTP: null
				};

				this.$http.post(this.url.update, this.vModel).then(
					response => {
						commonService.setStorage("transactionRefNo", "");
						this.isProcessing = false;
						this.$router.push("/transaction/confirmation/" + txnRefNumber);
					},
					error => {
						this.isProcessing = false;
					}
				);
			}
		}
	};
	function getDefaultData() {
		return {
			TransactionRefNumber: "",
			OTP: ""
		};
	}
</script>
